<template>
  <!-- <div id="header" class="fixed-top"> -->
  <div id="header" :class="headerClasses">
    <div class="container">
      <div class="header_wrap re_header">
        <div class="logo">
          <router-link to="/" class="logo_router">
            <div v-if="isOn" @click="removeOnClass">
              <!-- <img src="../../public/assets/images/logo.png" alt="" /> -->
              <img src="../assets/images/logo.png" alt="" />
            </div>
            <div v-else>
              <!-- <img src="../../public/assets/images/w_logo.png" alt="" /> -->
              <img src="../assets/images/w_logo.png" alt="" />
            </div>
          </router-link>
        </div>

        <div class="header_search">
          <div class="search_form">
            <form @submit.prevent="searchContent()">
              <!-- <form action="/contents" method="GET" onsubmit=""> -->
              <input id="search_type" type="hidden" value="" />
              <div>
                <input
                  id="search_txt"
                  v-model="searchTxt"
                  type="text"
                  class="input"
                  name="search_txt"
                  value=""
                  placeholder="콘텐츠 명을 입력하세요."
                  @keyup.enter="searchContent()"
                />
                <button class="submit">
                  <!-- <img
                    src="../../public/assets/images/icon/search_icon.png"
                    class="white"
                    alt=""
                    @click="searchContent()"
                  /> -->
                  <img
                    src="../assets/images/icon/search_icon.png"
                    class="white"
                    alt=""
                    @click="searchContent()"
                  />
                  <img
                    src="../assets/images/icon/search_on_icon.png"
                    class="block"
                    alt=""
                    @click="searchContent()"
                  />
                  <!-- <img
                    src="../../public/assets/images/icon/search_on_icon.png"
                    class="block"
                    alt=""
                    @click="searchContent()"
                  /> -->
                  <!--  -->
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="links">
          <div class="content">
            <ul>
              <li><a href="/contents">콘텐츠</a></li>
              <li><a href="/download">다운로드</a></li>
              <li><a href="/notice">공지사항</a></li>
              <li><a href="/faq">자주 묻는 질문</a></li>
              <li><a href="/inquiry">서비스 이용 문의</a></li>
            </ul>
          </div>
          <div class="member">
            <ul id="main_menu">
              <div v-if="!isLogin" id="login_yet">
                <li>
                  <a href="/join">회원가입</a>
                </li>
                <li>|</li>
                <li>
                  <a href="/login">로그인</a>
                </li>
              </div>
              <div v-else id="login_now">
                <li>
                  <a href="/mypage">마이페이지</a>
                </li>
                <li>|</li>
                <li><a @click="isLogout()">로그아웃</a></li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useCookies } from 'vue3-cookies' // 쿠키 관리를 위해 추가
import { loginStatus } from '../api/header.js'
import { loadContent } from '../api/boards'
// import { getData } from '../views/ContentViews.vue';
import { deleteToken } from '../api/loginout'
import { chekcAccT } from '../api/index'
import { chekcAccTest } from '../middleware/auth.js'

export default {
  name: 'AppHeader',
  setup() {
    const router = useRouter()
    const { cookies } = useCookies()

    const isLogin = ref(false)
    const isOn = ref(false)
    const searchTxt = ref('')

    // access_token 존재 여부를 확인하는 함수
    const checkLoginStatus = () => {
      isLogin.value = !!cookies.get('access_token')
    }
    const isLogout = async () => {
      await deleteToken()
      checkLoginStatus() // 로그아웃 후 상태 업데이트
    }
    const getresulContent = async () => {
      //   console.log("getresulContent 진입");
      // console.log(searchTxt.value);
      await loadContent(0, null, searchTxt.value)
      // const response = await loadContent(0, null, searchTxt.value);
      // console.log(response);
      // console.log(response[0]);
      // console.log(response[1]);
    }
    const searchContent = () => {
      if (searchTxt.value.trim()) {
        router.push({
          path: '/contents',
          name: 'ContentViews',
          query: {
            search_txt: searchTxt.value,
          },
        })
        getresulContent(0, null, searchTxt.value)
      }
    }
    // const searchContent = () => {
    //   if (searchTxt.value.trim()) {
    //     router.push({ path: '/contents', query: { search_txt: searchTxt.value.trim() } });
    //   }
    // }
    const observeHeaderClass = () => {
      const headerElement = document.getElementById('header')
      if (!headerElement) return
      const observer = new MutationObserver((mutationsList) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const mutation of mutationsList) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            isOn.value = headerElement.classList.contains('on')
          }
        }
      })
      // 관찰할 대상과 관찰 옵션 설정
      observer.observe(headerElement, { attributes: true })

      // 컴포넌트 언마운트 시 Observer 해제
      onUnmounted(() => {
        observer.disconnect()
      })
    }
    const removeOnClass = () => {
      const headerElement = document.getElementById('header')
      if (headerElement) {
        headerElement.classList.remove('on')
        isOn.value = false
      }
    }

    // 헤더 클래스를 동적으로 계산하는 계산된 속성 정의
    const headerClasses = computed(() => ({
      'fixed-top': true,
      on: router.currentRoute.value.path !== '/',
    }))

    // Navigation Guards 설정
    // const setupNavigationGuards = () => {
    //   router.beforeEach((to, from, next) => {
    //     // 네비게이션 이전에 수행할 작업 정의
    //     // 여기서는 헤더 클래스를 업데이트합니다.
    //     updateHeaderClass(to.path);
    //     next();
    //   });
    // };

    // 헤더 클래스 업데이트 함수
    const updateHeaderClass = (path) => {
      const headerElement = document.getElementById('header')
      if (headerElement) {
        if (path === '/') {
          headerElement.classList.remove('on')
        } else {
          headerElement.classList.add('on')
        }
      }
    }

    // 라우터 변경 감시
    watch(
      () => router.currentRoute.value.path,
      (newPath) => {
        updateHeaderClass(newPath)
      }
    )

    // 쿠키 변경 감시
    watch(
      () => cookies.get('access_token'),
      () => {
        checkLoginStatus()
      },
      { immediate: true } // 컴포넌트 마운트 시 즉시 실행
    )
    const checkResult = ref('')
    const ATchk = async () => {
      checkResult.value = await chekcAccTest()
      if (checkResult.value === 'MB23000200') {
        console.log('chekcAccTest 함수 진입')
        console.log('checkResult >>> ', checkResult)
        console.log('checkResult.value >::> ', checkResult.value)
        console.log('AppHeader에서 토큰 정상 작동일때 return함')
      } else if (checkResult.value === '4040011') {
        // 4040011
        // 로그인 세션 만료시 이쪽으로 들어옴
        console.log('MB23000200가 아닐때 여기로 진입함')
        console.log('4040011가 나옴')
        console.log('chekcAccTest 함수 진입')
        console.log('checkResult >>> ', checkResult)
        console.log('checkResult.value >::> ', checkResult.value)
        console.log('AppHeader에서 토큰 만료됐을때 작동함')
      } else {
        // 미로그인시 notYet이 return됨.
        console.log('미로그인임')
        console.log('checkResult.value >::> ', checkResult.value)
        console.log('ㅇㅇ 로그인 안 한 상태임.')
      }
    }
    // 페이지 로드 시 로그인 상태 확인
    onMounted(() => {
      updateHeaderClass(router.currentRoute.value.path)
      observeHeaderClass()
      isLogin.value = loginStatus()
      checkLoginStatus()
      ATchk()
    })
    return {
      isLogin,
      isOn,
      isLogout,
      removeOnClass,
      searchContent,
      searchTxt,
      headerClasses,
    }
  },
}
</script>
